// src/pages/Home.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Import images
import aboutSec1 from '../assets/img/core-img/about-sec1.png';
import aboutSec2 from '../assets/img/core-img/about-sec2.jpg';
import s1 from '../assets/img/services/s1.jpg';
import s2 from '../assets/img/services/s2.jpg';
import s3 from '../assets/img/services/s3.jpg';
import s4 from '../assets/img/services/s4.jpg';
import s5 from '../assets/img/services/s5.jpg';
import s6 from '../assets/img/services/s6.jpg';
import n3 from '../assets/img/icons/n3.png';
import n5 from '../assets/img/icons/n5.png';
import n6 from '../assets/img/icons/n6.png';
import n7 from '../assets/img/icons/n7.png';
import test1 from '../assets/img/test-img/1.jpg';
import test2 from '../assets/img/test-img/2.jpg';
import test3 from '../assets/img/test-img/3.jpg';

// Custom styles for banner layout
const bannerStyles = `
  .hero-section .col-12.col-lg-6.col-md-12:first-child {
    flex: 0 0 58% !important;
    max-width: 58% !important;
  }

  .hero-section .col-12.col-lg-6.col-md-12:last-child {
    flex: 0 0 42% !important;
    max-width: 42% !important;
  }

  .hero-section .welcome-content {
    padding-right: 30px !important;
  }

  .hero-section .welcome-content h1 {
    line-height: 1.2 !important;
    word-spacing: 0.05em !important;
  }

  @media (max-width: 991px) {
    .hero-section .col-12.col-lg-6.col-md-12:first-child,
    .hero-section .col-12.col-lg-6.col-md-12:last-child {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }

    .hero-section .welcome-content {
      padding-right: 15px !important;
      margin-bottom: 30px !important;
    }
  }

  @media (max-width: 768px) {
    .hero-section .welcome-content h1 {
      font-size: 2rem !important;
      line-height: 1.3 !important;
    }
  }
`;

export default function Home() {
  useEffect(() => {
    const $ = window.$;

    // Inject custom banner styles
    const styleElement = document.createElement('style');
    styleElement.setAttribute('data-banner-styles', 'true');
    styleElement.textContent = bannerStyles;
    document.head.appendChild(styleElement);

    // — INITIAL FAQ STATE: hide all answers, open only the first —
    if ($) {
      const $faq = $('.info-faq-area');
      $faq.find('dt').removeClass('active').next('dd').hide();
      $faq.find('dt').first().addClass('active').next('dd').show();
    }

 // — Owl Carousel + numbered dots —
 if ($ && $.fn.owlCarousel) {
  const $slider = $('.client_slides')
    .owlCarousel({
      items: 2,
      loop: true,
      margin: 30,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      responsive: {
        0:   { items: 1 },
        768: { items: 2 },
      },
    })
    // fire on init and on every change
    .on('initialized.owl.carousel changed.owl.carousel', () => {
      $slider.find('.owl-dot').each((i, dot) => {
        $(dot).text(String(i + 1).padStart(2, '0'));
      });
    });
}

// — WOW.js re-init (for your fadeInUp animations) —
if (window.WOW) {
  new window.WOW().init();
}

// — FAQ accordion binding —
if ($) {
  $('.info-faq-area dt')
    .off('click')
    .on('click', function() {
      const $dt = $(this);
      $dt.toggleClass('active')
         .next('dd').stop(true, true).slideToggle(300);
      $dt.siblings('dt').removeClass('active')
         .next('dd').stop(true, true).slideUp(300);
    });
}

    // Cleanup function to remove styles when component unmounts
    return () => {
      const existingStyle = document.querySelector('style[data-banner-styles]');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
}, []);

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section main-page section-padding" id="home">
        <div className="hero-section-content">
          <div className="container">
            <div className="row align-items-center">
              {/* Welcome Content */}
              <div className="col-12 col-lg-6 col-md-12">
                <div className="welcome-content">
                  <div className="promo-section">
                    <h3 className="special-head cyan">Professional Translation Solutions</h3>
                  </div>
                  <h1 className="fadeInUp bold" data-wow-delay="0.2s">
                    We are building bridges that give companies the ability to expand markets.
                  </h1>
                  <p className="w-text fadeInUp" data-wow-delay="0.3s">
                    Ardent Translations specializes in Indic languages and global rare languages, delivering expert translation and localization services that help your business reach international audiences with clarity and cultural sensitivity.
                  </p>
                  <div className="info-btn-group fadeInUp" data-wow-delay="0.4s">
                    <Link className="btn info-btn mr-3" to="/services">Our Services</Link>
                    <Link className="btn info-btn green-btn more-btn mr-3" to="/contact-us">Get a Quote</Link>
                  </div>
                </div>
              </div>
              {/* Hero Image */}
              <div className="col-12 col-lg-6 col-md-12">
                <div className="welcome-meter about-sec-wrapper text-right mt-s fadeInUp" data-wow-delay="0.4s">
                  <img
                    src={aboutSec1}
                    className="about-i"
                    alt="Translation Services"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Area */}
      <section className="our_services_area section-padding-100-0 relative map-before" id="services">
        <div className="container">
          <div className="section-heading text-center">
            <span>Our Services</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Translation Services</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              We offer a comprehensive suite of language services tailored to your needs.
            </p>
          </div>
          <div className="row">
            {[
              { img: s1, title: 'Translation Workflow', text: 'Separate native-speaker translators and dedicated proofreaders on every job—no matter the size—for consistent, publication-ready results.' },
              { img: s2, title: 'Market Localisation', text: 'Tailor products, campaigns, and documentation to local customs and buying habits, maximizing the “comfort factor” that drives purchase decisions.' },
              { img: s5, title: 'DTP Services', text: 'Full-service formatting in QuarkXPress, InDesign, Adobe Creative Suite, and more, ensuring layouts are ready for both print and web.' },
              { img: s3, title: 'Voiceover & Subtitling', text: 'Professional voice talent and accurate captioning for diverse multimedia video content worldwide.' },
              { img: s4, title: 'Multimedia Services', text: 'Localization of images, audio, graphics, text, and highly engaging interactive digital media.' },
              { img: s6, title: 'CAD Services', text: 'Technical drawing translation for engineering, architecture, construction, and industrial projects.' }
            ].map((svc, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="service_single_content text-center wow fadeInUp" data-wow-delay={`${0.2 + 0.1 * i}s`}>
                  <div className="serv_icon">
                    <img src={svc.img} alt="" />
                  </div>
                  <div className="service-content">
                    <h6 className="w-text bold">{svc.title}</h6>
                    <p className="g-text">{svc.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Area */}
      <section className="about-us-area section-padding-100 relative" id="about">
        <div className="container">
          <div className="row align-items-center">
            {/* About Text */}
            <div className="col-12 col-lg-6 col-md-12">
              <div className="who-we-contant">
                <div className="promo-section">
                  <h3 className="special-head">About Ardent Translations</h3>
                </div>
                <h4 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Your Partner in Professional Language Solutions</h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                 Ardent Translations is a one-stop translation and content partner serving clients across India. <strong>We specialize in Indic languages and global rare languages</strong>, with our in-house linguists and project managers working as an extension of your team, delivering language solutions that meet rigorous international standards.

                </p>
                  <p className="fadeInUp" data-wow-delay="0.4s">
               Mission: To be more than a vendor: to become your trusted partner for every multilingual need, from the first brief to the final deliverable, with special expertise in underserved linguistic communities.
                </p>

                <Link className="btn info-btn orange-btn mt-30 fadeInUp" data-wow-delay="0.7s" to="/contact-us">Contact Us</Link>
              </div>
            </div>
            {/* About Image */}
            <div className="col-12 col-lg-6 col-md-12 no-padding-left">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp mt-s" data-wow-delay="0.4s">
                <img
                  src={aboutSec1}
                  className="about-i"
                  alt="About Ardent Translations"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

  {/* Features Area (Why Choose Us) */}
  <section className="how section-padding-100-70 relative map-before">
    <div className="container">
      <div className="section-heading text-center">
        <span>Key Features</span>
        <h2 className="wow fadeInUp d-blue bold" data-wow-delay="0.3s">
          Why Choose Us
        </h2>
        <p className="wow fadeInUp" data-wow-delay="0.4s">
          Our translation services stand out for their quality, speed, and customization.
        </p>
      </div>
      <div className="row">
        {[
          { icon: n3, title: "Scalable Team Model", text: "Using a network of pre-vetted freelance specialists allows us to flex our capacity for peak volumes while keeping overhead—and thus your costs—lean year-round. " },
          { icon: n5, title: "Quality Assurance",     text: "Our workflow begins with Translation, where a hand-picked, subject-expert linguist produces the first draft for flawless domain accuracy." },
          { icon: n6, title: "Certified Experts",   text: "When you entrust your project to us, it is handled exclusively by certified experts—professionals who have earned formal credentials in their fields." },
          { icon: n7, title: "99 % On-Time Delivery", text: "Our proprietary project-management platform tracks each file from intake through release, slashing turnaround times and eliminating errors. " }
        ].map((feat, i) => {
          // Only Fast Turnaround (i===1) and Cultural Adaptation (i===3) get extra bottom margin:
          const extraBottom = (i === 1 || i === 3) ? { marginBottom: "50px" } : {};

          return (
            <div className="col-12 col-md-6 col-lg-3" key={i}>
              <div
                className="article special mts-50"
                style={extraBottom}
              >
                <img
                  src={feat.icon}
                  className="mb-10"
                  alt={feat.title}
                />
                <h3 className="article__title">{feat.title}</h3>
                <p>{feat.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>

      {/* Contact CTA Area */}
      <div className="contact_us_area section-padding-0-0" id="contact">
        <div className="container">
          <div className="call-us-sec v2">
            <div className="row align-items-center">
              <div className="col-12 col-lg-9">
                <h3 className="w-text fadeInUp" data-wow-delay="0.3s">Get Your Custom Quote</h3>
                <h2 className="bold w-text mb-0">Contact us for any translation inquiries</h2>
              </div>
              <div className="col-12 col-lg-3 right-on-lg">
                <Link className="btn info-btn more-btn fadeInUp mt-s" data-wow-delay="0.6s" to="/contact-us">Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

 {/* FAQ Area */}
 <div className="faq-timeline-area section-padding-100" id="faq">
        <div className="container">
          <div className="section-heading text-center">
            <span>Frequently Asked</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Translation FAQs</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              Answers to common questions about our translation services.
            </p>
          </div>
          <div className="row align-items-center">
            {/* FAQ Questions */}
            <div className="col-12 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-10 offset-sm-1">
              <div className="info-faq-area mt-s">
                <dl style={{ marginBottom: 0 }}>
                  <dt className="wave fadeInUp" data-wow-delay="0.2s">
                    What turnaround time can I expect?
                  </dt>
                  <dd className="fadeInUp" data-wow-delay="0.3s">
                    <p>Most projects are completed within 1–3 business days depending on length and complexity.</p>
                  </dd>

                  <dt className="wave fadeInUp" data-wow-delay="0.3s">
                    How do you ensure translation quality?
                  </dt>
                  <dd className="fadeInUp" data-wow-delay="0.4s">
                    <p>Every document undergoes a two-step review by native-speaking linguists and editors.</p>
                  </dd>

                  <dt className="wave fadeInUp" data-wow-delay="0.4s">
                    Can you handle specialized industries?
                  </dt>
                  <dd className="fadeInUp" data-wow-delay="0.5s">
                    <p>Yes, we serve legal, medical, technical, marketing, and other industry sectors.</p>
                  </dd>

                  <dt className="wave fadeInUp mb-0" data-wow-delay="0.5s">
                    Do you offer desktop publishing (DTP)?
                  </dt>
                  <dd className="fadeInUp" data-wow-delay="0.6s">
                    <p>We provide DTP to preserve layout and design in translated documents.</p>
                  </dd>
                </dl>
              </div>
            </div>

            {/* FAQ Image */}
            <div className="col-12 col-lg-6">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp" data-wow-delay="0.4s">
                <img
                  src={aboutSec2}
                  alt="FAQ Illustration"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Testimonial Slider */}
      <section className="testimonials-area map-bg map-before section-padding-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-4">
              <div className="section-heading text-left">
                <span>What Clients Say</span>
                <h2 className="d-blue bold bl-text wow fadeInUp" data-wow-delay="0.3s">
                  Loved By Our Clients
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.4s">
                  How Ardent Translations has helped businesses communicate globally.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="client_slides owl-carousel">
                {[
                  {
                    img: test1,
                    quote: `"Ardent Translations translated our entire product manual into five languages. Excellent quality and fast delivery."`,
                    name: 'Tech Solutions Ltd',
                    role: 'Product Manager'
                  },
                  {
                    img: test2,
                    quote: `"The localization of our website boosted our international sales by 30%. Outstanding cultural adaptation."`,
                    name: 'GlobalShop',
                    role: 'Marketing Director'
                  },
                  {
                    img: test3,
                    quote: `"Their medical translation services are incredibly accurate and reliable. Perfect for specialized content."`,
                    name: 'HealthCare Corp',
                    role: 'Clinical Lead'
                  }
                ].map((t, i) => (
                  <div className="single-testimonial text-center" key={i}>
                    <div className="testimonial_image">
                      <img src={t.img} alt={t.name} />
                    </div>
                    <div className="testimonial-description">
                      <div className="testimonial_text"><p>{t.quote}</p></div>
                      <div className="admin_text">
                        <h5>{t.name}</h5>
                        <p>{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
